import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  subtitle,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-189">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-navy/60 backdrop-blur-sm overflow-y-auto" onClick={onClose} data-id="element-190">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} onClick={e => e.stopPropagation()} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-xl my-8 max-h-[calc(100vh-4rem)] overflow-y-auto" data-id="element-191">
            {/* Header */}
            <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-5 flex items-start justify-between gap-4 rounded-t-2xl z-10" data-id="element-192">
              <div className="min-w-0" data-id="element-193">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-navy" data-id="element-194">
                  {title}
                </h2>
                {subtitle && <p className="text-sm text-muted mt-1" data-id="element-195">{subtitle}</p>}
              </div>
              <button onClick={onClose} aria-label="Close" className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-navy hover:bg-surface transition-colors" data-id="element-196">
                <X size={20} data-id="element-197" />
              </button>
            </div>

            {/* Body */}
            <div className="px-6 py-6" data-id="element-198">{children}</div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}